// extracted by mini-css-extract-plugin
module.exports = {"column":"ReportWithFilters_column_1o859","view":"ReportWithFilters_view_JxO_V","sidenavWidth":"ReportWithFilters_sidenavWidth_21Nu9"};